<template>
  <vx-card
    v-bind:title="reservation.event.title"
    title-color="primary"
    v-bind:subtitle="formatDate(reservation.event.startdate)">
    <vs-row
      vs-align="center"
      vs-type="flex" vs-justify="end" vs-w="12">
      <vs-button @click="openAlert('danger')" color="danger" type="filled" icon-pack="feather" class=""
                 icon="icon-trash"/>
    </vs-row>
    <h6>Name: {{reservation.user.firstname}} {{reservation.user.lastname}}</h6>
    <vs-divider color="#ECECEC"/>
    <h6>Email: {{reservation.user.email}}</h6>
    <vs-divider color="#ECECEC"/>
    <h6>Buchungsnummer: <strong>{{reservation.referencenumber}}</strong></h6>
    <vs-divider color="#ECECEC"/>
    <h6>Anmeldedatum: <strong>{{formatDate(reservation.created_at)}}</strong></h6>
    <vs-divider color="#ECECEC"/>
    <h6>Anzahl Plätze: <strong>{{reservation.numplaces}}</strong></h6>
    <vs-divider color="#ECECEC"/>
    <h6>Typ: <strong>{{reservation.price_text!=='' && reservation.price_text!==null?reservation.price_text:"Standard"}}</strong></h6>
    <vs-divider color="#ECECEC"/>
    <h6>Nummer: <strong v-if="reservation.nums">{{reservation.nums}}</strong><strong v-else>Platz wird am Flohmarkttag vom Veranstalter zugeteilt</strong></h6>
    <vs-divider color="#ECECEC"/>
    <h6>Gesamtsumme: <strong>{{reservation.numplaces * reservation.price}}</strong></h6>
    <vs-divider color="#ECECEC"/>
    <h6>Eingecheckt: <strong v-if="reservation.checkin === 1">ja</strong><strong v-else>nein</strong></h6>
    <vs-divider color="#ECECEC"/>
    <!--<h6 v-if="reservation.usercomment">Kundenbemerkung/Wunsch:<br><br><strong>{{reservation.usercomment}}</strong></h6>
    <vs-divider v-if="reservation.usercomment" color="#ECECEC"/>-->
    <vs-row
      vs-align="center"
      vs-type="flex"
      vs-justify="space-between"
      vs-w="12">
<!--      <a :href="'https://api.flohmarktkoenig.ch/v1/reservations/' + reservation.id + '/invoice'" target="_blank">-->
<!--        <vs-button color="success" type="filled" icon-pack="feather" class="" icon="icon-file"/>-->
<!--      </a>-->
<!--      <a :href="'https://dev-api.flohmarktkoenig.ch/v1/reservations/' + reservation.id + '/invoice'" target="_blank">-->
<!--        <vs-button color="success" type="filled" icon-pack="feather" class="" icon="icon-file"/>-->
<!--      </a>-->
      <a :href="baseUrl + '/v1/reservations/' + reservation.id + '/invoice'" target="_blank">
        <vs-button color="success" type="filled" icon-pack="feather" class="" icon="icon-file"/>
      </a>
      <vs-button
        @click="openConfirmationPopup(reservation)"
        color="primary"
        type="filled"
        v-if="reservation.status === '1'">
        Bestätigen
      </vs-button>
      <a href="#" v-if="reservation.status === '2'" @click="showConfirmationPopup = true">Bestätigung anzeigen</a>
    </vs-row>
    <vx-modal class="confirm-modal" title="Sind Sie sicher?" :active.sync="showConfirmPopUp"  v-if="showConfirmPopUp" detach>
      <p>Sind Sie sicher, dass Sie die Reservierung bestätigen möchten?</p>
      <vs-row vs-type="flex" vs-justify="end" class="pt-12" vs-w="12">
        <vs-button @click="onConfirmPress(reservation)" color="success" type="filled">Ja</vs-button>
      </vs-row>
    </vx-modal>
    <!--    Email pop up-->
    <vx-modal classContent="popup-example-confirm" title="Bestätigung senden" :active.sync="showEmailEditorPopup"  v-if="showEmailEditorPopup" detach >
      <vs-row vs-type="flex" vs-align="center" vs-w="12">
        <vs-row>
          <quill-editor id="shit" style="width: 100%;" v-model="content"></quill-editor>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="end" class="pt-32" vs-w="12">
          <vs-button @click="showConfirmPopUp=true" color="primary" type="filled">Bestätigung senden</vs-button>
        </vs-row>
      </vs-row>
    </vx-modal>
    <!--    Email pop up-->
    <!--    confirmation pop up-->
    <vx-modal classContent="popup-example" title="Bestätigung" :active.sync="showConfirmationPopup"  v-if="showConfirmationPopup" detach>
      <vs-row vs-type="flex" vs-align="center" vs-w="12">
        <vs-row>
          <div v-html="reservation.emailmessage" />
        </vs-row>
      </vs-row>
    </vx-modal>
    <!--    confirmation pop up-->
  </vx-card>
</template>

<script>
  import TYPES from "../../utils/enums/StatusTypes"
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import {mapActions, mapGetters} from "vuex";

  export default {
    components: {
      quillEditor
    },
    data: () => ({
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      allEvents: [],
      name: "ReservationCard",
      colorAlert: 'primary',
      titleAlert: 'Alert',
      activeAlert: false,
      valueInput: '',
      accepted: TYPES.reservationStatus.ACCEPTED,
      pending: TYPES.reservationStatus.PENDING,
      //email
      content: `...`,
      showEmailEditorPopup: false,
      showConfirmPopUp: false,
      showConfirmationPopup: false
    }),
    props: {
      reservation: {
        type: Object,
      }
    },
    computed: {
      ...mapGetters(['getPendingReservations']),
      ...mapGetters(['getApprovedReservations']),
      windowWidth: () => {
        return this.$store.state.windowWidth
      },
    },
    methods: {
      ...mapActions(['deleteReservation']),
      ...mapActions(['fetchPendingReservations']),
      ...mapActions(['fetchApprovedReservations']),
      ...mapActions(['confirmReservation']),
      ...mapActions(['fetchAllPendingReservations']),
      ...mapActions(['fetchAllApprovedReservations']),
      openAlert(color) {
        this.colorAlert = color
        this.$vs.dialog({
          color: this.colorAlert,
          title: `Sind Sie sicher?`,
          text: color === 'danger' ? 'Sind Sie sicher, dass Sie die Reservierung löschen möchten?' : 'Sind Sie sicher, dass Sie die Reservierung annehmen möchten?',
          accept: this.acceptAlert,
          acceptText: 'JA'
        })
      },
      formatDate(dateString) {
        let date = new Date(dateString)
        return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
      },
      openConfirmationPopup(reservation) {
        this.showEmailEditorPopup = true
        let numbers = 'Platz wird am Flohmarkttag vom Veranstalter zugeteilt';
        let planLink = '';
        if (reservation.nums !== null) {
          if (reservation.nums.length > 0) {
            numbers = reservation.nums
            planLink = `<br><br><a href="https://www.flohmarktkoenig.ch/plan-all.pdf">Flohmarktplan zeigen</a>`;
          }
        }
        this.content = `<p>Hallo ${reservation.user.firstname} ${reservation.user.lastname}<br><br>Danke für Ihre Einzahlung.<br>Gerne bestätigen wir Ihre Reservation für <b>"${reservation.event.title}"</b> Flohmarkt am <b>"${this.formatDate(reservation.event.startdate)}"<br><br>Typ: ${reservation.price_text?reservation.price_text:"Standard"}<br>Anzahl Plätze: ${reservation.numplaces}<br>Nummer: ${numbers}${planLink}<br><br>Bitte bringen Sie die <a href="https://api.flohmarktkoenig.ch/v1/reservations/${reservation.id}/invoice">Rechnung</a> für die Zutrittskontrolle mit.</p>`
      },
      acceptAlert() {
        this.deleteReservation(this.reservation.id).then((res) => {
          if (res === true) {
            if (this.reservation.status === '1') {
              let updatedPendingReservations = this.getPendingReservations.filter((obj) => {
                return obj.id !== this.reservation.id
              })
              this.fetchPendingReservations(updatedPendingReservations)
              this.fetchAllPendingReservations()
            }
            if (this.reservation.status === '2') {
              let updatedApprovedReservations = this.getApprovedReservations.filter((obj) => {
                return obj.id !== this.reservation.id
              })
              this.fetchApprovedReservations(updatedApprovedReservations)
              this.fetchAllApprovedReservations()
            }
            if(this.colorAlert !== 'danger'){
              this.$toast.success('Reservierung akzeptiert')
            }else{
              this.$toast.error('Reservierung gelöschte')
            }
            
          }
        })
      },
      onConfirmPress(reservation) {
        this.showConfirmPopUp = false
        this.showEmailEditorPopup = false
        let payload = {
          id: reservation.id,
          email: this.content
        }
        this.confirmReservation(payload).then((res) => {
          if (res === true) {
            this.$toast.success('Bestätigung gesendet')
            let updatedPendingReservations = this.getPendingReservations.filter((obj) => {
              return obj.id !== reservation.id
            })
            this.fetchPendingReservations(updatedPendingReservations)
            this.fetchAllPendingReservations()

            let updatedApprovedReservations = this.getApprovedReservations
            updatedApprovedReservations.push(reservation)
            this.fetchApprovedReservations(updatedApprovedReservations)
            this.fetchAllApprovedReservations()
          } else {
            this.$toast.error('Ein Fehler ist auf getreten')
          }
        })
      }
    },
  }
</script>

<style scoped>
  .confirm-modal {
    z-index: 99999999;
  }
</style>
